import React from 'react';
import { Modal } from 'react-bootstrap';
import { LabelText } from '../../Language';
import './UnblockCrSuccess.css';



const TranslationErrorPopup = (props) => {
    const handleClose = () => {
        props.setShowPopup(!props.showPopup);
    };

    return (
        <div className="UnblockSuccess-Modal-container">
            <Modal dialogClassName={"Model-translation"} show={true}
                onHide={handleClose}
                backdrop="static"
                keyboard={true}
                scrollable={true}>
                {
                    <Modal.Header closeButton={true}
                        className="UnblockSuccess-Modal-header scroller"
                        style={{ backgroundColor: '#25336C' }} >
                        <div >
                            <LabelText tid="attention" />
                        </div>
                    </Modal.Header>
                }
                <Modal.Body>
                    <div translate="no" className="UnblockSuccess-BusinessPartner-label-period">
                        <LabelText tid="instruction_donot_translate" />
                    </div>
                </Modal.Body>

            </Modal>
        </div>
    )
};

export default TranslationErrorPopup;